export interface NewsletterDialogProps {
  open: boolean;
  onClose: () => void;
  origin: Origin;
}

export enum SubscriptionProcessStatus {
  Initial = 'Initial',
  Subscribed = 'Subscribed',
  Failed = 'Failed',
}

export enum ButtonAction {
  None = 'None',
  Reset = 'Reset',
  Submit = 'Submit',
}

export interface NewsletterDialogForm {
  email: string;
}

export enum Origin {
  OnlineFooter = 'OnlineFooter',
  OnlinePopup = 'OnlinePopup',
}
